// extracted by mini-css-extract-plugin
module.exports = {"container":"bento-box_container__WsloN","containerMargin":"bento-box_containerMargin__GtSts"};